export default "__VITE_PUBLIC_ASSET__4091bbc3__"